import { Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { DictionaryEntry } from '@sdbn/common';
import { TransortOptionParameterValue, TransportOption } from '../../transport-options.model';

@Component({
  selector: 'app-transport-option-editor-parameter',
  templateUrl: './transport-option-editor-parameter.component.html',
  styleUrls: ['./transport-option-editor-parameter.component.scss']
})
export class TransportOptionEditorParameterComponent implements OnInit {

  transportOption: TransportOption;
  visibleParameterValues = new Array<TransortOptionParameterValue>();

  @Input('transportOption') set setTransportOption(transportOption: TransportOption) {
    this.transportOption = transportOption;
    this.updateVisibleParameterValues();
  }

  @Output() changed = new EventEmitter();

  currentEditingParameterValue: TransortOptionParameterValue

  formGroup = new FormGroup({
    hasParameter: new FormControl(false, []),
  });

  constructor() {

    this.formGroup.valueChanges.subscribe(values => {
      this.transportOption.hasParameter = values.hasParameter;
    });
  }

  public ngOnInit() {
    this.formGroup.reset({
      hasParameter: this.transportOption.hasParameter
    });
  }

  onParameterNameChanged(entry: DictionaryEntry) {
    this.transportOption.parameterName = entry;
  }

  onParameterValueChanged(entry: DictionaryEntry) {
    this.currentEditingParameterValue.value = entry;
    console.log('transport option', this.transportOption);
  }

  addParameterValue() {

    let nextId = 0;

    for (const v of this.transportOption.parameterValues) {
      if (v.id < nextId) {
        nextId = v.id;
      }
    }
    nextId--;

    const value = new TransortOptionParameterValue({ id: nextId });
    this.transportOption.parameterValues.push(value);
    this.currentEditingParameterValue = value;
    this.updateVisibleParameterValues();
  }

  editParameterValue(value: TransortOptionParameterValue) {
    this.currentEditingParameterValue = value;
  }

  deleteParameterValue(value: TransortOptionParameterValue) {
    value.deleted = true;
    this.updateVisibleParameterValues();
  }

  unselectParameterValue() {
    this.currentEditingParameterValue = null;
  }

  private updateVisibleParameterValues() {
    this.visibleParameterValues = this.transportOption == null ? [] : this.transportOption.parameterValues.filter(v => !v.deleted);
  }
}
